export default "/images/icon-check-stroke.svg?4e03a574f3b87955921c1c0ebbd6bf65";